import React from 'react';
import useProductManagement from "../hook/useProductManagement";
import ProductManagement from '../components/ProductManagement';

const ProductManagePage = () => {
    const product = useProductManagement();
    return <ProductManagement {...product} />;
}

export default ProductManagePage;
